<template>
  <v-container>
    <v-row>
      <!-- 用户欢迎信息 -->
      <v-col cols="12" md="4">
        <v-card class="mb-4">
          <v-card-title class="d-flex justify-space-between align-center">
            {{ $t('userDashboard.welcome') }}, {{ userName }}
            <v-list-item>
              <v-list-item-subtitle>{{ $t('userDashboard.lastLoginTime') }} {{ lastLoginTime }}</v-list-item-subtitle>
            </v-list-item>
          </v-card-title>
          <v-card-text>
            <v-list-item>
              <v-row>
                <v-col cols="6">
                  <v-list-item-title>
                    {{ $t('userDashboard.currentLoginIp') }}: {{ currentLoginIp }}
                  </v-list-item-title>
                </v-col>
                <v-col cols="6">
                  <v-list-item-title>
                    {{ $t('userDashboard.lastLoginIp') }}: {{ lastLoginIp }}
                  </v-list-item-title>
                </v-col>
              </v-row>
            </v-list-item>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- 快速统计信息 -->
      <v-col cols="12" md="4">
        <v-card class="mb-4">
          <v-card-title>{{ $t('userDashboard.quickStats') }}</v-card-title>
          <v-card-text>
            <v-list-item>
              <v-row>
                <v-col cols="4">
                  <v-list-item>
                    <v-list-item-title>{{ $t('userDashboard.orderCount') }}</v-list-item-title>
                    <v-list-item-subtitle>{{ orderCount }}</v-list-item-subtitle>
                  </v-list-item>
                </v-col>
                <v-col cols="4">
                  <v-list-item>
                    <v-list-item-title>{{ $t('userDashboard.productCount') }}</v-list-item-title>
                    <v-list-item-subtitle>{{ productCount }}</v-list-item-subtitle>
                  </v-list-item>
                </v-col>
                <v-col cols="4">
                  <v-list-item>
                    <v-list-item-title>{{ $t('userDashboard.orderAmount') }}</v-list-item-title>
                    <v-list-item-subtitle>{{ orderAmount }}</v-list-item-subtitle>
                  </v-list-item>
                </v-col>
              </v-row>
            </v-list-item>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card>
          <v-card-title>{{ $t('userDashboard.superior') }}</v-card-title>
          <v-card-subtitle>
            <v-row>
              <v-col cols="10">
                <v-text-field v-model="superior" readonly disabled></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-btn icon @click="copySuperior">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>

    <!-- 登录日志 -->
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>{{ $t('userDashboard.loginLog') }}</v-card-title>
          <v-card-text>
            <v-data-table
          :headers="localizedHeaders"
          :items="loginLogs"
          class="elevation-1"
        >
        <template v-slot:item[region]="{ item }">
          <span>{{ getRegionFromIP(item.IP) }}</span>
        </template>
        </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
  </template>
  
  <script>
  import { fetchUserDashboard } from '@/api/apiService';
  export default {
    name: 'UserDashboard',
    data() {
      return {
        userName: '',
        currentLoginIp: '',
        lastLoginIp: '',
        lastLoginTime: '',
        orderCount: 0,
        productCount: 0,
        orderAmount: 0,
        loginLogs: [],
        loading: false,
        superior: ''
      };
    },
    props: {
      walletConnect: {
        type: Object,
        required: true
      }
    },
    computed: {
      localizedHeaders() {
        const currentLocale = this.$i18n.locale;
        return [
          { title: this.$t('userDashboard.loginTime', currentLocale), value: 'Time' },
          { title: this.$t('userDashboard.loginIp', currentLocale), value: 'IP' },
          { title: this.$t('userDashboard.loginRegion', currentLocale), value: 'region' },
        ];
      }
    },
    methods: {
      setLoading(value) {
        this.loading = value;
        if(value){
          this.$toast.showMarkLoading();
        } else {
          this.$toast.hideMarkLoading();
        }
      },
      async getUserInfo() {
        console.log(this.walletConnect);
        if(this.walletConnect.isConnected) {
          let userInfo = await this.walletConnect.getUserInfo(this.$store.state.walletAddress);
          console.log("wallet dashboard", userInfo);
          this.superior = userInfo.inviteAddress;
        }
      },
      copySuperior() {
        navigator.clipboard.writeText(this.superior);
        this.$toast.success(this.$t('userDashboard.copySuccess'));
      },
      loadDashboard() {
        fetchUserDashboard().then(async response => {
          response = response.data;
          this.userName = response.data.userName;
          this.currentLoginIp = response.data.currentLoginIp;
          this.lastLoginIp = response.data.lastLoginIp;
          this.lastLoginTime = response.data.lastLoginTime;
          this.orderCount = response.data.orderCount;
          this.productCount = response.data.productCount;
          this.orderAmount = response.data.productAmount;
          const loginLogs = response.data.loginLogs.map(log => {
            let logData = {};
            log = log.split(', ');
            log.forEach(entry => {
              const[key, value] = entry.split(': ');
              logData[key.trim()] = value.trim();
            });
            return logData;
          });
          await Promise.all(loginLogs.map(async log => {
            log.region = await this.getRegionFromIP(log.IP);
          }));
          this.loginLogs = loginLogs;
          console.log(this.loginLogs, "loginLogs");
        });
      },
      async getRegionFromIP(ip) {
        let region = localStorage.getItem('region'+ip);
        if(region){
          return region;
        }
        if(ip != null && ip != ''){
          try {
            const response = await fetch(`http://ip-api.com/json/${ip}`);
            const data = await response.json();
            console.log(data, "getRegionFromIP data");
            localStorage.setItem('region'+ip, data.regionName);
            return data.regionName || 'Unknown';
          } catch (error) {
            console.error('Error fetching IP data:', error);
            return 'Unknown';
          }
        }
      }
    },
    mounted() {
      this.loadDashboard();
      if(this.walletConnect.isConnected) {
        this.getUserInfo();
      }
    },
  };
  </script>
  
  <style scoped>
.v-card {
  margin-bottom: 20px;
}
  </style>